import { render, staticRenderFns } from "./LanguagesTranslationsSharedContent.vue?vue&type=template&id=62269b6b&scoped=true&"
import script from "./LanguagesTranslationsSharedContent.vue?vue&type=script&lang=js&"
export * from "./LanguagesTranslationsSharedContent.vue?vue&type=script&lang=js&"
import style0 from "./LanguagesTranslationsSharedContent.vue?vue&type=style&index=0&id=62269b6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62269b6b",
  null
  
)

export default component.exports